import React from 'react';

const StatusBadge = ({ name, status = 'online', isDark = false }) => {
  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 16px',
        backgroundColor: isDark ? '#161b22' : 'white',
        borderRadius: '20px',
        fontSize: '14px',
        color: isDark ? '#adbac7' : '#595959',
        border: isDark ? '1px solid #30363d' : '1px solid #e8e8e8',
      }}
    >
      {/* Status Dot */}
      <span
        style={{
          width: '8px',
          height: '8px',
          borderRadius: '50%',
          backgroundColor: status === 'online' ? '#52c41a' : '#8c8c8c',
          display: 'inline-block',
        }}
      />
      
      {/* Name */}
      <span style={{ fontWeight: '500' }}>{name}</span>
    </div>
  );
};

export default StatusBadge;